
import * as React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import apps from 'src/display/apps';
import platform from 'src/display/platform';
import UIAppContainer from './UI.AppContainer';

export default function modulesRoute() {
    // <Route path="*/platform/gettingStarted" component={platform.GettingStarted} />
    return (
        <Switch>
            <Route path="*/m/:appKey" component={UIAppContainer} />
            <Route path="*/app/:appKey" component={UIAppContainer} />
            <Route path="*/error/:type?" component={require('./UI.AppError').default} />
            <Route path="*/myApp" render={() => <Redirect to="/hide/m/Kingxunlian.AppStore/?routing=list%2Fmyapp" />} />
            <Route path="*/invoiceInput" component={apps.InvoiceInput} />
            <Route path="*/appSearch" component={apps.AppSearch} />
            <Route path="*/invoiceManage" component={apps.InvoiceManage} />
            <Route path="*/OutputSettlement" component={apps.OutputSettlement} />
            <Route path="*/inputSettlement" component={apps.InputSettlement} />
            <Route path="*/authManage" component={apps.AuthManage} />
            <Route path="*/invoiceCompare" component={apps.InvoiceCompare} />
            <Route path="*/platform/network" component={platform.Network} />
            <Route path="*/platform/inBox" component={platform.InBox} />
            <Route path="*/platform/companyinfo" component={platform.CompanyInfo} />
            <Route path="*/platform/appStore" component={platform.AppStore} />
            <Route path="*/platform/help" component={platform.HelpCenter} />
            <Route path="*/platform/organization" component={platform.Organization} />
            <Route path="*/platform/document" component={platform.Document} />
            <Route path="*/platform/usermanage" component={platform.UserMange} />
            <Route path="*/platform/groupInfo" component={apps.GroupInfo} />
            <Route path="*/platform" component={platform.UserCenter} />
            <Route render={() => <Redirect to="/hide/error" />} />
        </Switch>
    );
}


// WEBPACK FOOTER //
// ./src/display/modules/Home/Workbench3/Modules.Route.tsx